import { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { caseService } from "../../../_services/case.service";
import { StandardViewPanel } from "../../../_components/panel/standardView.panel";
import { CaseManageDrawer } from "../../case/case-manage";


export const CaseDetailsPanel = () => {

    const resetData = () => ({
        id: "",
        clientId: "",
        clientName: "",
        clientContactId: "",
        clientPOC: "",
        clientReference: "",
        isActive: ""
       

    });

    const { caseId } = useParams<{ caseId: string }>();
    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchData()
    }, [caseId]);


    function fetchData() {
        if (!caseId) return;
        setIsLoading(true);
        return caseService
            .get(caseId)
            .then(
                (json: any) => {
                    
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }
    const rows = [
        { label: 'Client', value: data.clientName },
        { label: 'Client POC', value: data.clientPOC },
        { label: 'Reference', value: data.clientReference }
    ]

    return (
        <>
            <StandardViewPanel
                title="Case Details"
                buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageCase/" + data.id) }, disabled: !data?.id }

                ] }
                loading={isLoading}
                items={rows} />

            <Routes>
                <Route path="ManageCase/:id" element={<CaseManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>
        </>
    );
};

